// @ts-check

import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'

// status [new, init , done]

const module = {
  state: {
    categories: [],
    showDialog: false,
    relModel: null,
    relId: null
  },

  getters: {
    getCategories: state => state.categories,
    getShowDialog: state => state.showDialog,
    getRelModel: state => state.relModel,
    getRelId: state => state.relId
  },

  mutations: {
    SET_CATEGORIES (state, payload) { state.categories = payload },
    SET_SHOW_DIALOG (state, payload) { state.showDialog = payload },
    SET_REL_MODEL (state, payload) { state.relModel = payload },
    SET_REL_ID (state, payload) { state.relId = payload }
  },

  actions: {
    showReportDialog: ({ commit, state }, payload) => {
      const { relModel, relId } = payload
      state.relModel = relModel
      state.relId = relId
      state.showDialog = true
    },
    submit: ({ commit }, input) => {
      return ApiUtils.postData({ data: [{ api: 'M1101UserReportService.createReport', input }] })
    },
    saveVerdiction: ({ commit }, input) => {
      return ApiUtils.postData({ data: [{ api: 'M1201ReportCaseService.saveVerdiction', input }] })
        .then((data) => {
          return data[0].output.data[0]
        })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
